import { isDevMode } from '@angular/core';
import type { MecapEnvironment } from '../environment/type';
import { defaultMecapEnv } from '../mecap/default';

export const environment = {
  ...defaultMecapEnv,
  applicationName: 'DEMO',
  isAngularDevMode: isDevMode(),
  apiUrl: 'https://meapp-demo.plaveoodev.pctrade.hu/api',

  googleMapsApiKey: 'AIzaSyBIVk1MrShNeH3eumzyUyBCNAuBkq0v_hM',
  apiUrlPattern: /^https:\/\/meapp-demo\.plaveoodev\.pctrade\.hu\/api(\/.*)?$/i,
  keycloakConfig: {
    realm: 'meapp-demo',
    url: 'https://keycloak.milo.plaveoo.hu/',
    clientId: 'ui://86c218a1-baed-4d34-83d4-c9a7e6c18145',
    initOptions: {
      onLoad: 'check-sso',
      redirectUri: window.location.origin,
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    },
  },
} as const satisfies MecapEnvironment;
